import React from "react";
import paths from "routes/paths";

import { NavItemType } from "./nav-item";

export const NAV_MAIN: NavItemType[] = [
  {
    label: "Email Tools",
    type: "head",
  },
  {
    icon: (
      <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M8.09998 2.35001C4.92434 2.35001 2.34998 4.92437 2.34998 8.10001C2.34998 11.2756 4.92434 13.85 8.09998 13.85C11.2756 13.85 13.85 11.2756 13.85 8.10001C13.85 4.92437 11.2756 2.35001 8.09998 2.35001ZM0.349976 8.10001C0.349976 3.8198 3.81977 0.350006 8.09998 0.350006C12.3802 0.350006 15.85 3.8198 15.85 8.10001C15.85 12.3802 12.3802 15.85 8.09998 15.85C3.81977 15.85 0.349976 12.3802 0.349976 8.10001Z"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M12.3429 12.3429C12.7334 11.9524 13.3666 11.9524 13.7571 12.3429L17.3571 15.9429C17.7476 16.3334 17.7476 16.9666 17.3571 17.3571C16.9666 17.7476 16.3334 17.7476 15.9429 17.3571L12.3429 13.7571C11.9523 13.3666 11.9523 12.7334 12.3429 12.3429Z"
          fillRule="evenodd"
        />
      </svg>
    ),
    label: "Search",
    path: paths.searchSingle(),
    type: "link",
  },
  {
    icon: (
      <svg viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M1.30839 1.69386C1.79868 1.20357 2.46365 0.928131 3.15702 0.928131H9.61444C9.87966 0.928131 10.134 1.03349 10.3215 1.22102L15.1646 6.06409C15.3521 6.25163 15.4575 6.50598 15.4575 6.7712V16.4573C15.4575 17.1507 15.1821 17.8157 14.6918 18.306C14.2015 18.7962 13.5365 19.0717 12.8432 19.0717H3.15702C2.46365 19.0717 1.79868 18.7962 1.30839 18.306C0.818104 17.8157 0.542664 17.1507 0.542664 16.4573V3.54249C0.542664 2.84912 0.818104 2.18414 1.30839 1.69386ZM3.15702 2.92813C2.99408 2.92813 2.83782 2.99286 2.7226 3.10807C2.60739 3.22329 2.54266 3.37955 2.54266 3.54249V16.4573C2.54266 16.6203 2.60739 16.7765 2.7226 16.8917C2.83782 17.007 2.99408 17.0717 3.15702 17.0717H12.8432C13.0061 17.0717 13.1624 17.007 13.2776 16.8917C13.3928 16.7765 13.4575 16.6203 13.4575 16.4573V7.18541L9.20023 2.92813H3.15702Z"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M7.3263 7.43048C7.708 7.08258 8.29185 7.08258 8.67355 7.43048L11.1397 9.67825C11.5479 10.0503 11.5772 10.6828 11.2051 11.0909C10.8331 11.4991 10.2006 11.5284 9.79245 11.1564L8.99993 10.434V13.8606C8.99993 14.4128 8.55221 14.8606 7.99993 14.8606C7.44764 14.8606 6.99993 14.4128 6.99993 13.8606V10.434L6.2074 11.1564C5.79922 11.5284 5.16674 11.4991 4.7947 11.0909C4.42267 10.6828 4.45197 10.0503 4.86015 9.67825L7.3263 7.43048Z"
          fillRule="evenodd"
        />
      </svg>
    ),
    label: "Bulk Search",
    path: paths.searchBulk(),
    type: "link",
  },
  {
    icon: (
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
      </svg>
    ),
    label: "Verify",
    path: paths.verify(),
    type: "link",
  },
  {
    label: "Lead Tools",
    type: "head",
  },
  {
    beta: true,
    icon: (
      <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M48 188.6C48 111.7 111.7 48 192 48s144 63.7 144 140.6c0 45.6-23.8 101.5-58.9 157.1-28.3 44.8-61 84.8-85.1 112.1-24.1-27.3-56.7-67.2-85.1-112.1-35.1-55.5-58.9-111.5-58.9-157.1zM192 0C86 0 0 84.4 0 188.6 0 307.9 120.2 450.9 170.4 505.4 182.2 518.2 201.8 518.2 213.6 505.4 263.8 450.9 384 307.9 384 188.6 384 84.4 298 0 192 0zM160 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z" />
      </svg>
    ),
    label: "GeoLead Finder",
    path: paths.extractMap(),
    type: "link",
  },
  {
    icon: (
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 256c0-46.6 12.5-90.4 34.3-128.9L144.1 318.3c21.9 39.2 63.8 65.7 111.9 65.7 14.3 0 27.1-2.3 40.8-6.6L220.5 509.6C95.9 492.3 0 385.3 0 256zm365.1 65.6c12.3-19.2 18.9-42.5 18.9-65.6 0-38.2-16.8-72.5-43.3-96l152.7 0c12 29.6 18.6 62.1 18.6 96 0 141.4-114.6 255.1-256 256L365.1 321.6zM477.8 128L256 128c-62.9 0-113.7 44.1-125.5 102.7L54.2 98.5C101 38.5 174 0 256 0 350.8 0 433.5 51.5 477.8 128zM344 256a88 88 0 1 1 -176 0 88 88 0 1 1 176 0z" />
      </svg>
    ),
    label: "Browser Extension",
    path: paths.chromeExtensionStore(),
    type: "link",
  },
  {
    label: "Automation",
    type: "head",
  },
  {
    icon: (
      <svg viewBox="0 0 22 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.575 5.64911C5.96111 5.25422 5.95399 4.62109 5.5591 4.23498C5.16421 3.84887 4.53109 3.85599 4.14498 4.25088L5.575 5.64911ZM0.900024 8.99999L0.185014 8.30088C-0.194972 8.68951 -0.194972 9.31048 0.185014 9.69911L0.900024 8.99999ZM4.14498 13.7491C4.53109 14.144 5.16421 14.1511 5.5591 13.765C5.95399 13.3789 5.96111 12.7458 5.575 12.3509L4.14498 13.7491ZM17.4551 4.25088C17.0689 3.85599 16.4358 3.84887 16.0409 4.23498C15.646 4.62109 15.6389 5.25422 16.025 5.64911L17.4551 4.25088ZM20.7 8.99999L21.415 9.69911C21.795 9.31048 21.795 8.68951 21.415 8.30088L20.7 8.99999ZM16.025 12.3509C15.6389 12.7458 15.646 13.3789 16.0409 13.765C16.4358 14.1511 17.0689 14.144 17.4551 13.7491L16.025 12.3509ZM7.84801 16.8625C7.71687 17.399 8.04547 17.9403 8.58196 18.0714C9.11845 18.2025 9.65967 17.8739 9.79081 17.3374L7.84801 16.8625ZM13.7508 1.13744C13.8819 0.600956 13.5533 0.0597349 13.0168 -0.0714056C12.4803 -0.202546 11.9391 0.126054 11.808 0.662543L13.7508 1.13744ZM4.14498 4.25088L0.185014 8.30088L1.61503 9.69911L5.575 5.64911L4.14498 4.25088ZM0.185014 9.69911L4.14498 13.7491L5.575 12.3509L1.61503 8.30088L0.185014 9.69911ZM16.025 5.64911L19.985 9.69911L21.415 8.30088L17.4551 4.25088L16.025 5.64911ZM19.985 8.30088L16.025 12.3509L17.4551 13.7491L21.415 9.69911L19.985 8.30088ZM9.79081 17.3374L13.7508 1.13744L11.808 0.662543L7.84801 16.8625L9.79081 17.3374Z" />
      </svg>
    ),
    label: "API",
    path: paths.settingsApi(),
    type: "link",
  },
  {
    icon: (
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M201.1 57.3c-7 5.3-9.1 10.7-9.1 14.7 0 4.2 2.4 10.1 10.4 15.6 7.8 5.3 13.6 14.6 13.6 25.6 0 17-13.8 30.7-30.7 30.7L56 144c-4.4 0-8 3.6-8 8l0 52.5c7.4-2.9 15.5-4.5 24-4.5 43.1 0 72 39.4 72 80s-28.9 80-72 80c-8.5 0-16.6-1.6-24-4.5L48 456c0 4.4 3.6 8 8 8l100.5 0c-2.9-7.4-4.5-15.5-4.5-24 0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24l52.5 0c4.4 0 8-3.6 8-8l0-129.3c0-17 13.8-30.7 30.7-30.7 11.1 0 20.3 5.8 25.6 13.6 5.5 8 11.4 10.4 15.6 10.4 4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9-4-23.8-9.3-30.9-10.7-9.1-14.7-9.1c-4.2 0-10.1 2.4-15.6 10.4-5.3 7.8-14.6 13.6-25.6 13.6-17 0-30.7-13.8-30.7-30.7l0-81.3c0-4.4-3.6-8-8-8l-81.3 0c-17 0-30.7-13.8-30.7-30.7 0-11.1 5.8-20.3 13.6-25.6 8-5.5 10.4-11.4 10.4-15.6 0-4-2.1-9.5-9.1-14.7S245 48 232 48 208.2 52 201.1 57.3zM172.3 18.9C188.5 6.8 209.6 0 232 0S275.5 6.8 291.7 18.9 320 49.5 320 72c0 8.6-1.8 16.7-4.9 24L360 96c30.9 0 56 25.1 56 56l0 44.9c7.3-3.1 15.4-4.9 24-4.9 22.5 0 41 12.2 53.1 28.3s18.9 37.3 18.9 59.7-6.8 43.5-18.9 59.7-30.6 28.3-53.1 28.3c-8.6 0-16.7-1.8-24-4.9l0 92.9c0 30.9-25.1 56-56 56l-78.1 0c-18.7 0-33.9-15.2-33.9-33.9 0-10.1 4.5-18.5 9.9-24.2 4.2-4.3 6.1-9.2 6.1-13.9 0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9 5.5 5.7 9.9 14.1 9.9 24.2 0 18.7-15.2 33.9-33.9 33.9L56 512c-30.9 0-56-25.1-56-56L0 329.9c0-18.7 15.2-33.9 33.9-33.9 10.1 0 18.5 4.5 24.2 9.9 4.3 4.2 9.2 6.1 13.9 6.1 9.9 0 24-10.7 24-32s-14.1-32-24-32c-4.7 0-9.5 1.9-13.9 6.1-5.7 5.5-14.1 9.9-24.2 9.9-18.7 0-33.9-15.2-33.9-33.9L0 152c0-30.9 25.1-56 56-56l92.9 0c-3.1-7.3-4.9-15.4-4.9-24 0-22.5 12.2-41 28.3-53.1z" />
      </svg>
    ),
    label: "Integrations",
    path: paths.integrations(),
    type: "link",
  },
];
